import hdapi from "../common/hdapi";
import {loadjs} from "../common/utils";
const iconv = require("iconv-lite");
const fs = require("fs");

window.dataLayer = window.dataLayer || [];
var softInfo = {
	name: "迅捷压缩软件",
	version: "V3.9.4",
	platform: hdapi.platform,
	ga: "UA-117273948-23",
};

window.$softInfo = softInfo;

loadjs("https://www.googletagmanager.com/gtag/js?id=" + softInfo.ga).then(function (data) {
	console.log(dataLayer.push);
});

function gtag() {
	dataLayer.push(arguments);
}
window.gtag = gtag;

async function getPackgageName() {
	let mainPath = await hdapi.getPath("main");
	let arr = hdapi.split(mainPath);
	// let arr = mainPath.split("\\");
	arr.splice(arr.length - 3, arr.length);
	arr = hdapi.arrayjoin(arr);
	let ss = hdapi.join(arr, "set.ini");
	// let ss = arr.join("\\") + "\\set.ini";
	console.log(ss);
	let content = "";
	// debugger;
	let byte = fs.readFileSync(ss);
	if (
		(byte[0] === 0xef && byte[1] === 0xbb) ||
		(byte[0] === 0xfe && byte[1] === 0xff) ||
		(byte[0] === 0xff && byte[1] === 0xfe)
	) {
		// 已经是utf8
		console.log("object fileName 已经是utf-8，只是拷贝");
		content = byte;
		return;
	}
	console.log("非utf-8");
	byte = iconv.decode(byte, "gbk");
	content = "\ufeff" + byte.toString("utf8");
	// console.log(content)
	var snsArr = content.split(/[(\r\n)\r\n]+/);
	var fiItem = snsArr.filter((item) => {
		return item.includes("APPStore");
	});
	if (fiItem.length == 0) {
		fiItem = snsArr.filter((item) => {
			return item.includes("SetupName");
		});
	}
	// console.log(fiItem)
	console.log("window.PACKAGENAME", fiItem.join("").split("=")[1]);
	window.PACKAGENAME = fiItem.join("").split("=")[1];
	window.gtag("set", {
		package_msg: window.PACKAGENAME,
	});
}
console.log(window.PACKAGENAME);
gtag("js", new Date());
gtag("config", softInfo.ga, {
	custom_map: {
		dimension1: "Version",
		dimension2: "package_msg",
		dimension3: "task_result",
		dimension4: "isLogin_VIP",
		dimension5: "FileSize",
		dimension6: "Version_session",
		dimension7: "Version_user",
		dimension8: "Location",
	},
});
getPackgageName();

function gevt(name, category, label, result, Login_VIP, Size, location) {
	if (!location) location = "null";
	gtag("event", name, {
		event_category: category,
		event_label: label,
		Version_session: "来源_" + softInfo.name + "_" + softInfo.version + "_" + softInfo.platform,
		Version_user: "来源_" + softInfo.name + "_" + softInfo.version + "_" + softInfo.platform,
		Version: "来源_" + softInfo.name + "_" + softInfo.version + "_" + softInfo.platform,
		task_result: result,
		isLogin_VIP: Login_VIP,
		FileSize: Size,
		Location: location,
	});
}
export default window.gevt = gevt;
